import { render, staticRenderFns } from "./customerModify.vue?vue&type=template&id=6f2357f4&scoped=true"
import script from "./customerModify.vue?vue&type=script&lang=js"
export * from "./customerModify.vue?vue&type=script&lang=js"
import style0 from "./customerModify.vue?vue&type=style&index=0&id=6f2357f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2357f4",
  null
  
)

export default component.exports